import { CARECREDIT, GENERIC, PAYSOL, UNIVERSAL } from 'const/account/clients'
import config from 'const/config'

const getApigeeClientId = (client: string): string => {
  if (client === PAYSOL || client === CARECREDIT) {
    return `${config.PSCC_APIGEE_CLIENT_ID}`
  }
  if (client === UNIVERSAL || client === GENERIC) {
    return `${config.UNIVERSAL_APIGEE_CLIENT_ID}`
  }

  return `${config.RC_APIGEE_CLIENT_ID}`
}

export default getApigeeClientId
